import { render, staticRenderFns } from "./ActivityTransactionDetails.vue?vue&type=template&id=68257f73&scoped=true"
import script from "./ActivityTransactionDetails.vue?vue&type=script&lang=js"
export * from "./ActivityTransactionDetails.vue?vue&type=script&lang=js"
import style0 from "./ActivityTransactionDetails.vue?vue&type=style&index=0&id=68257f73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68257f73",
  null
  
)

export default component.exports